//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'

export default {
  name: 'rb-seo-frame-advisor-faq',

  data() {
    return {
      faqLink: wcs.getEndPoint('faq'),
      mainEntity: [],
    }
  },

  computed: {
    answersAsHTML() {
      return this.mainEntity.map((element) => element.acceptedAnswer?.text)
    },
    mainEntityLength() {
      return this.mainEntity?.length ?? 0
    },
    questions() {
      return this.mainEntity.map((element) => element.name)
    },
  },

  mounted() {
    if (document.readyState === 'complete') {
      this.boot()
    } else {
      document.addEventListener(
        'readystatechange',
        (e) => {
          if (e.target.readyState === 'complete') this.boot()
        },
        false
      )
    }
  },

  beforeDestroy() {
    document.removeEventListener('readystatechange', this.boot)
  },

  methods: {
    boot() {
      const scriptElements = document.querySelectorAll('script[type="application/ld+json"]')

      scriptElements.forEach((scriptElement) => {
        const jsonData = JSON.parse(scriptElement.textContent || '[]')
        if (Array.isArray(jsonData)) {
          jsonData.forEach((item) => {
            if (item['@type'] === 'FAQPage') {
              this.mainEntity = item.mainEntity ?? []
            }
          })
        }
      })
    },
  },
}
